module.exports = __webpack_public_path__ + "img/lg_ring_g_c_null_1@3x.b5b0effc.png";